const parseErrorMessage = (error) => {
    return error.isAxiosError ? `${error.message}: ${error.response.data[0].message}` : error.message
}

export default parseErrorMessage
